import { EmptyState } from '../ui/States';
import screen from './screen.module.css';

export function NotFound() {
  return (
    <div className={screen.screen}>
      <h1 className="t-title">Not found</h1>
      <EmptyState message="There's nothing at this address." action={{ label: 'Go to Dig', to: '/dig' }} />
    </div>
  );
}
